import React from 'react';
import TSGPromptPage from '../../components/TSGPromptPage';

const TenantTSGPromptPage = () => {
  return <TSGPromptPage mode="tenant" />;
};

export default TenantTSGPromptPage;
